<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_fiscal"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >NF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N°Carga</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NF Inicial"
              v-model="emi_nf_ini"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NF Final"
              v-model="emi_nf_fim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="doc_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Doc Incicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="doc_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Doc Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="manifesto"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >MDFE</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="red_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Redespacho</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="red_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Redespacho</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emi_nome"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Razão Social Emitente</label
              >
            </div>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="emi_cnpj"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ Emitente</label
              >
            </div>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Doc Inicial"
              v-model="emi_doc_ini"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão Doc Final"
              v-model="emi_doc_fim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="cd_ocorrencia"
              :options="this.$parent.optionsCodOcorrencia"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Ocorrência"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
              v-model="unidade"
              :options="this.$parent.unidadeOptions"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Unidade"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Ocorrencia Inicial"
              v-model="ocorrencia_ini"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Ocorrencia Final"
              v-model="ocorrencia_fim"
              class="form-control"
              show-decade-nav
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>

          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({ params: [], search: "" }),
      cd_ocorrencia: [],
      num_fiscal: "",
      emi_nf_ini: "",
      num_carga: "",
      emi_nf_fim: "",
      emi_nome: "",
      emi_cnpj: "",
      red_nome: "",
      red_cnpj: "",
      doc_ini: "",
      doc_fim: "",
      emi_doc_ini: "",
      unidade: "",
      emi_doc_fim: "",
      manifesto: "",
      ocorrencia_ini: "",
      ocorrencia_fim: "",
      data_filter: [],
    };
  },
  mounted() {},
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        cd_ocorrencia: this.cd_ocorrencia,
        num_fiscal: this.num_fiscal,
        num_carga: this.num_carga,
        manifesto: this.manifesto,
        emi_nf_ini: this.formatDateSubmit(this.emi_nf_ini),
        emi_nf_fim: this.formatDateSubmit(this.emi_nf_fim),
        emi_nome: this.emi_nome,
        emi_cnpj: this.emi_cnpj,
        red_nome: this.red_nome,
        red_cnpj: this.red_cnpj,
        doc_ini: this.doc_ini,
        doc_fim: this.doc_fim,
        emi_doc_ini: this.formatDateSubmit(this.emi_doc_ini),
        emi_doc_fim: this.formatDateSubmit(this.emi_doc_fim),
        unidade: this.unidade,
        ocorrencia_ini: this.formatDateSubmit(this.ocorrencia_ini),
        ocorrencia_fim: this.formatDateSubmit(this.ocorrencia_fim),
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.cd_ocorrencia = "";
      this.num_fiscal = "";
      this.manifesto = "";
      this.emi_nf_ini = "";
      this.num_carga = "";
      this.emi_nf_fim = "";
      this.emi_nome = "";
      this.emi_cnpj = "";
      this.red_nome = "";
      this.red_cnpj = "";
      this.doc_ini = "";
      this.doc_fim = "";
      this.emi_doc_ini = "";
      this.emi_doc_fim = "";
      this.ocorrencia_ini = "";
      this.unidade = "";
      this.ocorrencia_fim = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>
